import React, { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";

const DISMISS_KEY = "ss_install_dismissed";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () =>
  /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(DISMISS_KEY) === "true") return;
    const iosDevice = isIOS();
    setIos(iosDevice);
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (iosDevice) setShow(true); // iOS Safari never fires beforeinstallprompt
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => {
    setShow(false);
    localStorage.setItem(DISMISS_KEY, "true");
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    setShow(false);
    setDeferred(null);
    if (outcome) localStorage.setItem(DISMISS_KEY, "true");
  };

  if (!show) return null;

  return (
    <div
      className="relative mt-6 ss-card p-4 border-[#E7DFBE] bg-[#F7F2D7]"
      data-testid="install-prompt"
    >
      <button
        onClick={dismiss}
        data-testid="install-dismiss"
        aria-label="Dismiss install prompt"
        className="absolute right-3 top-3 text-[#8a6d10]/70 hover:text-[#8a6d10] ss-focus"
      >
        <X size={16} strokeWidth={2} />
      </button>
      <div className="flex items-start gap-3 pr-6">
        <span className="mt-0.5 shrink-0 rounded-lg bg-[#1A1A1A] p-2">
          <Download size={16} color="#C9A227" strokeWidth={2} />
        </span>
        <div className="flex-1">
          <p className="text-[14.5px] font-semibold text-[#1A1A1A]">
            Add Signal State ID to your home screen
          </p>
          {ios ? (
            <p className="mt-1 text-[13px] leading-relaxed text-[#5c5326]">
              Tap the <Share size={13} className="inline -mt-0.5" strokeWidth={1.8} /> Share button,
              then choose <span className="font-semibold">“Add to Home Screen.”</span> Keep your
              private check-in one tap away.
            </p>
          ) : (
            <>
              <p className="mt-1 text-[13px] leading-relaxed text-[#5c5326]">
                Keep your private check-in one tap away — no app store needed.
              </p>
              <button
                onClick={install}
                data-testid="install-button"
                className="mt-3 inline-flex items-center gap-2 rounded-full bg-[#1A1A1A] px-4 py-2 text-[13px] font-medium text-[#FDFBF7] ss-tap ss-focus"
              >
                <Download size={15} strokeWidth={1.75} /> Install app
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
